// hooks/useQueryState.ts
import { useSearchParams } from "react-router-dom";

export function useQueryState<T = string>(
  key: string,
  defaultValue: T
): [T, (value: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();

  const rawValue = searchParams.get(key);
  const value = rawValue !== null ? (rawValue as unknown as T) : defaultValue;

  const setValue = (newValue: T) => {
    const newParams = new URLSearchParams(searchParams);
    if (newValue === undefined || newValue === null || newValue === "") {
      newParams.delete(key);
    } else {
      newParams.set(key, String(newValue));
    }
    setSearchParams(newParams);
  };

  return [value, setValue];
}
